/*
 * Frise « À quel âge sécuriser quoi ? » - Securidou
 * Sélecteur de stade de développement (tablist accessible). Tous les panneaux
 * sont pré-rendus dans le HTML (crawlables/citables) ; le JS ne fait que
 * basculer la visibilité du stade actif. Aucune dépendance, aucun AJAX.
 *
 * Conventions : préfixe CSS sd-tool__, data-attributes, role tablist/tab/tabpanel.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'sd_frise_v1';
  var DEFAULT_STAGE = 'rampe';

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    var root = document.querySelector('[data-frise]');
    if (!root) return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-stage-btn]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-stage-panel]'));
    if (!tabs.length || !panels.length) return;

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function saveStage(stage) {
      try {
        localStorage.setItem(STORAGE_KEY, stage);
      } catch (e) {
        /* stockage indisponible - on ignore */
      }
    }

    function restoreStage() {
      try {
        return localStorage.getItem(STORAGE_KEY);
      } catch (e) {
        return null;
      }
    }

    function activate(stage, opts) {
      opts = opts || {};
      var found = false;
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-stage-btn') === stage;
        if (on) found = true;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
      });
      if (!found) return;
      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-stage-panel') !== stage;
      });
      saveStage(stage);

      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'tool_stage', tool: 'frise-age', stage: stage });
      } catch (e) {
        /* noop */
      }

      if (opts.focus) {
        var activeTab = root.querySelector('[data-stage-btn="' + stage + '"]');
        if (activeTab) activeTab.focus();
      }
      if (opts.scroll) {
        var panel = root.querySelector('[data-stage-panel="' + stage + '"]');
        if (panel) panel.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'nearest' });
      }
    }

    /* Clic */
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-stage-btn'), { scroll: true });
      });
    });

    /* Navigation clavier (tablist : flèches, Home, End) */
    root.addEventListener('keydown', function (e) {
      var current = tabs.indexOf(document.activeElement);
      if (current === -1) return;
      var next = -1;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (current + 1) % tabs.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (current - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = tabs.length - 1;
      if (next === -1) return;
      e.preventDefault();
      activate(tabs[next].getAttribute('data-stage-btn'), { focus: true });
    });

    /* Init : stade mémorisé ou défaut */
    var saved = restoreStage();
    var initial = DEFAULT_STAGE;
    if (saved && root.querySelector('[data-stage-btn="' + saved + '"]')) initial = saved;
    activate(initial, {});
  });
})();
